import { Workflow } from 'modules/workflows/types';
import { TriggerJourney } from 'modules/workflows/context/TriggerJourneyContext/TriggerJourney.types';
import { JourneyItem } from './JourneyItem';
import { WorkflowOption } from './WorkflowSelect.types';
import { PublishedJourney } from 'modules/workflowNodeEditors/components/StartNodeEditor/EntranceLimitForm/ConcurrentJourneyEntranceCriteriaUtils/PublishedJourneysContext';

export const parseItem = (data: TriggerJourney | PublishedJourney) => {
  const { name, id: optionId, workflowType, enabled } = data;
  return {
    id: `${optionId}-${workflowType}`,
    label: <JourneyItem {...{ name, workflowType, id: optionId, enabled }} />,
    value: `${optionId}`,
    data,
  } as WorkflowOption;
};

export const parseItems = (
  data: TriggerJourney[] | PublishedJourney[] = [],
  workflow: Partial<Workflow>,
) => {
  const associatedWfId = workflow?.workflowReference?.id;
  return data.map((item) => {
    const isCurrentJourney = [associatedWfId, workflow.id].includes(item.id);

    return {
      ...parseItem(item),
      // Disable the current workflow and the associated live/draft workflow. This
      // is to prevent a workflow from triggering itself.
      // See: [WF-5074](https://iterable.atlassian.net/browse/WF-5074)
      isDisabled: isCurrentJourney,
      ...(isCurrentJourney && { tooltipContent: 'A journey cannot trigger itself' }),
    };
  });
};
